import React from 'react';
import moment from 'moment';

import { Link } from '@i18n';
import { BLOG_ARTICLE } from '@routes';
import { CountryNames } from './countryNames';
import {
  GoNext,
  Quotes,
  StyledArticleSummary,
  StyledCardInner,
  StyledCardWrapper,
  StyledCircularFrame,
  StyledCountry,
  StyledPatientName,
  StyledPostImage,
  StyledTreatmentName,
  StyledHowOld,
  StyledCountryFlag
} from './styles';

const Testimonial = ({ testimonial, size }) => {
  const calcHowOld = () => {
    if (moment().diff(testimonial.attributes.published_at, 'days') < 32) {
      return `${moment().diff(testimonial.attributes.published_at, 'days')} days ago`;
    }
    return `${moment().diff(testimonial.attributes.published_at, 'months')} months ago`;
  };

  return (
    <StyledCardWrapper size={size || { mobile: 1 / 2, tablet: 1 / 3 }}>
      <Link
        passHref
        href={BLOG_ARTICLE}
        params={{ slug: testimonial.attributes.slug }}
      >
        <StyledCardInner>
          <GoNext id="gonext" />
          <StyledCircularFrame>
            <StyledPostImage src={testimonial.attributes.cover_image.url} alt="cover" />
          </StyledCircularFrame>
          <StyledCountry>
            <StyledCountryFlag
              src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${CountryNames[testimonial.relationships.patient.data?.address_country]}.svg`}
              alt="flag"
            />
            {testimonial.relationships.patient.data?.address_country}
          </StyledCountry>
          <StyledPatientName>{testimonial.relationships.patient.data?.name}</StyledPatientName>
          <StyledTreatmentName>
            {testimonial.relationships.treatment.data?.name}
          </StyledTreatmentName>
          {testimonial.attributes.article_summary && (
            <StyledArticleSummary>
              <div dangerouslySetInnerHTML={{ __html: testimonial.attributes.article_summary }} />
              <Quotes src="../../../../../../static/images/svg/double-quotes.svg" id="quote" />
              <Quotes src="../../../../../../static/images/svg/double-quotes.svg" rev id="quote" />
            </StyledArticleSummary>
          )}
          <StyledHowOld />
          <StyledHowOld>{calcHowOld()}</StyledHowOld>
        </StyledCardInner>
      </Link>
    </StyledCardWrapper>
  );
};

export default Testimonial;
